/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PerformerList } from './PerformerList';
import {
    PerformerListFromJSON,
    PerformerListFromJSONTyped,
    PerformerListToJSON,
    PerformerListToJSONTyped,
} from './PerformerList';

/**
 * 
 * @export
 * @interface PaginatedPerformerListList
 */
export interface PaginatedPerformerListList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedPerformerListList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPerformerListList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPerformerListList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<PerformerList>}
     * @memberof PaginatedPerformerListList
     */
    results: Array<PerformerList>;
}

/**
 * Check if a given object implements the PaginatedPerformerListList interface.
 */
export function instanceOfPaginatedPerformerListList(value: object): value is PaginatedPerformerListList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedPerformerListListFromJSON(json: any): PaginatedPerformerListList {
    return PaginatedPerformerListListFromJSONTyped(json, false);
}

export function PaginatedPerformerListListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedPerformerListList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(PerformerListFromJSON)),
    };
}

  export function PaginatedPerformerListListToJSON(json: any): PaginatedPerformerListList {
      return PaginatedPerformerListListToJSONTyped(json, false);
  }

  export function PaginatedPerformerListListToJSONTyped(value?: PaginatedPerformerListList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(PerformerListToJSON)),
    };
}

